<template>
  <div class="ChukuBill app-container">
    <!--标题-->
    <div class="detailsTitle"  style="margin-bottom: 0;">
      <h4>出库提单</h4>
    </div>
    <div ref="searchBox">
      <div class="formBox margbot ">
        <el-form ref="searchForm" :inline="true" size="mini" class="demo-form-inline" label-width="100px">
          <div class="formItemBox">
          <el-form-item label="提货单号:" >
            <el-input v-model="searchForm.billNo" maxlength="50" placeholder="请输入提货单号"  size="mini">
            </el-input>
          </el-form-item>
          <el-form-item label="提货日期:" >
            <el-date-picker size="mini" v-model="dateList" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="一级货主:" >
            <el-select v-model="searchForm.primaryCustomerTaxId" clearable filterable placeholder="请选择"
               size="mini">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:" >
            <el-select v-model="searchForm.secondaryCustomerTaxId" clearable filterable placeholder="请选择"
               size="mini">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="货权方:" >
          <el-select v-model="searchForm.ownerCustomerTaxId" clearable filterable placeholder="请选择"  size="mini">
              <el-option
                v-for="(item, index) in HQData"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber"
              >
              </el-option>
            </el-select>
        </el-form-item> -->
          <el-form-item label="车牌号:" >
            <el-input v-model="searchForm.plateNumber" placeholder="请输入车牌号"  size="mini"></el-input>
          </el-form-item>
          <el-form-item label="产地:" >
            <el-input v-model="searchForm.steelMillName" placeholder="请输入产地"  size="mini"></el-input>
          </el-form-item>
          <el-form-item label="规格:" >
            <el-input v-model="searchForm.specification" placeholder="请输入规格"  size="mini"></el-input>
          </el-form-item>
          <el-form-item label="单据状态:" >
            <el-select v-model="searchForm.emptyBillType" clearable placeholder="请选择单据状态"  size="mini">
              <el-option v-for="(item, index) in statusData" :key="index" :label="item.show_name" :value="item.item_no">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否失效:" >
            <el-select v-model="searchForm.invalidFlag" clearable placeholder="请选择单据状态" size="mini" >
              <el-option v-for="(item, index) in invalidFlagData" :key="index" :label="item.show_name"
                :value="item.item_no"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外部单号:" >
            <el-input v-model="searchForm.outBillNo" placeholder="请输入外部单号"  size="mini"></el-input>
          </el-form-item>
          <el-form-item label="材质:" >
            <el-input v-model="searchForm.model" placeholder="请输入材质"  size="mini"></el-input>
          </el-form-item>
          </div>
          <el-form-item style="margin:10px 0 10px 0;">
            <el-button type="primary" size="mini" @click="searchClick" btnCode="003P01CB001" v-if="btnFlg[0]">查询
            </el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="003P01CB002" v-if="btnFlg[1]">重置
            </el-button>
            <el-button type="primary" size="mini" @click="addPlan" btnCode="003P01CB003" v-if="btnFlg[2]">添加出库计划
            </el-button>
            <el-button type="primary" size="mini" @click="addPlanClick" btnCode="003P01CB008" v-if="btnFlg[7]">添加出库计划
            </el-button>
            <!-- 念头西库20240125 -->
             <el-button type="primary" size="mini" @click="addPlanClick1"  v-if="btnFlg[11]">添加出库计划
            </el-button>
            <el-button type="primary" size="mini" @click="finished" btnCode="003P01CB004" v-if="btnFlg[3]">完成
            </el-button>
            <el-button type="primary" size="mini" @click="cancellation" btnCode="003P01CB005" v-if="btnFlg[4]">作废
            </el-button>
            <el-button type="primary" size="mini" @click="xinzeng" btnCode="003P01CB006" v-if="btnFlg[5]">新增</el-button>
            <span>
              总吨数:
              <span style="color: red">{{ allWeightT }}</span> &nbsp;吨
            </span>
            <span style="margin-left: 15px">
              总件数:
              <span style="color: red">{{ allNumberT }}</span> &nbsp;件
            </span>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div :style="{ height: h }" v-loading='tabLoadingA'>
      <el-table size="mini" border bordersize="mini" height="100%" ref="tableList" :data="tableList" style="width:100%"
        :row-style="{ height: '20px' }" :cell-style="{ padding: '0px' }" class="elTab"
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @row-click="dianjixuanzhong">
        <el-table-column :show-overflow-tooltip="true" type="index" prop="date" width="55" label="序号" align="center">
        </el-table-column>
        <el-table-column label="操作" width="200px">
          <template v-slot="scope">

            <span v-if="scope.row.emptyBillType == 1 || scope.row.emptyBillType == 0">
              <el-button v-if="btnFlg[10]" type="text" @click="addRC(scope.row)"
                btnCode="003M2T0100">&nbsp;&nbsp;添加人车&nbsp;&nbsp;</el-button>
            </span>
            <span v-if="scope.row.source == '0' && scope.row.emptyBillType == '0'">
              <el-button v-if="btnFlg[8]" type="text" @click="tianjiahuowu(scope.row)"
                btnCode="003P01CB009">&nbsp;&nbsp;添加货物&nbsp;&nbsp;</el-button>
            </span>
            <span v-if="scope.row.source == '0' && scope.row.emptyBillType == '0'">
              <el-button v-if="btnFlg[9]" type="text" @click="tianjiahuowuTwo(scope.row)"
                btnCode="003P01CB00A">&nbsp;&nbsp;添加货物&nbsp;&nbsp;</el-button>
              <el-button v-if="btnFlg[12]" type="text" @click="tianjiahuowuTwo1(scope.row)"  >&nbsp;&nbsp;添加货物&nbsp;&nbsp;</el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="billNo" label="提货单号" width="220px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="outBillNo" label="外部单号" width="150px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="提货日期" width="160px">
          <template slot-scope="scope">
            <div>
              <span
                v-if="scope.row.createTime != '' || scope.row.createTime != undefined || scope.row.createTime != null">{{
                  scope.row.createTime
                  | dateFormat }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="" label="提货状态" width="80px">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.emptyBillType == '0'" style="color:orange;">{{ scope.row.emptyBillTypeName }}</span>
              <span v-if="scope.row.emptyBillType == '1'">{{ scope.row.emptyBillTypeName }}</span>
              <span v-if="scope.row.emptyBillType == '2'" style="color:#999;">{{ scope.row.emptyBillTypeName }}</span>
              <span v-if="scope.row.emptyBillType == '3'" style="color:green;">{{ scope.row.emptyBillTypeName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="invalidFlag" label="是否失效" width="80px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220px">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="secondaryCustomerName" label="二级货主" width="220px">
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="ownerCustomerName" label="货权方" width="220px">
        </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="billTransferredGoods" label="提货总量（吨）" width="120px">
          <template v-slot="scope">
            <div>
              <span v-if="scope.row.billTransferredGoods == undefined || scope.row.billTransferredGoods == ''">0</span>
              <span v-else>{{ Number(scope.row.billTransferredGoods).toFixed(3) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="actualBillTransferred" label="实际提货总量（吨）" width="150px">
          <template v-slot="scope">
            <div>
              <span v-if="scope.row.actualBillTransferred == undefined || scope.row.actualBillTransferred == ''">0</span>
              <span v-else>{{ Number(scope.row.actualBillTransferred).toFixed(3) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车牌号" width="120px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="120px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="120px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="身份证号" width="120px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="carHoldFalg" label="是否扣车" width="80px">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.carHoldFalg == '0'">不扣</span>
              <span v-else>扣车</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="effectiveTime" label="有效开始时间" width="160px">
          <template slot-scope="scope">
            <div>
              <span
                v-if="scope.row.effectiveTime != '' || scope.row.effectiveTime != undefined || scope.row.effectiveTime != null">{{
                  scope.row.effectiveTime
                  | dateFormat }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="failureTime" label="有效结束时间" width="160px">
          <template slot-scope="scope">
            <div>
              <span
                v-if="scope.row.failureTime != '' || scope.row.failureTime != undefined || scope.row.failureTime != null">{{
                  scope.row.failureTime
                  | dateFormat }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="" label="提单照片">
          <template slot-scope="scope">
            <div>
              <el-button v-if="scope.row.source != 0" type="text" size="small" @click="handleClick(scope.row, 'zp')">查看提单
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="sourceName" label="数据来源" width="90px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="" label="备注" width="70px">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="small" @click="handleClick(scope.row, 'bz')">查看</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="voidName" label="作废人" width="150px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="voidReason" label="作废原因" width="150px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="voidTime" label="作废时间" width="160px">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.voidTime != '' || scope.row.voidTime != undefined || scope.row.voidTime != null">{{
                scope.row.voidTime
                | dateFormat }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="searchForm.pageNo"
        :page-size="searchForm.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="totalA">
      </el-pagination>
    </div>
    <!--出库单详情-->
    <div ref="searchBox2">
      <div class="detailsTitle">
        <h4>货物明细</h4>
      </div>
      <p class="detailsTitle-sum">
        <el-button type="primary" btnCode="003P01CB007" v-if="btnFlg[6]" @click="delXQ">删除</el-button>
        <span>总吨数：<span class="num">{{ Number(allWeight).toFixed(3)
        }}</span>&nbsp;吨</span><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;总件数：<span class="num">{{ allNumber
}}</span>&nbsp;件</span>
      </p>
      <!--详情表格-->
      <div class="ruKuZuoyeWarp-body-detailsTab">
        <div class="ruKuZuoyeWarp-body-table" :style="{ height: detailsH }">
          <el-table height="100%" border bordersize="mini" size="mini" ref="tabref" :data="subTableData"
            style="width:100%" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            @row-click="dianjiXiangqingtable">
            <el-table-column prop="productTypeName" label="货物类型"></el-table-column>
            <el-table-column prop="steelMillName" label="产地" width="250px"></el-table-column>
            <el-table-column prop="model" label="材质"></el-table-column>
            <el-table-column prop="specification" label="规格"></el-table-column>
            <el-table-column prop="number" label="件数"></el-table-column>
            <el-table-column prop="weight" label="重量（吨）">
              <template v-slot="scope">
                <div>
                  <span v-if="scope.row.weight == undefined || scope.row.weight == ''">0</span>
                  <span v-else>{{ Number(scope.row.weight).toFixed(3) }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="availableNumber" label="可计划件数"></el-table-column>
            <el-table-column prop="availableWeight" label="可计划重量（吨）">
              <template v-slot="scope">
                <div>
                  <span v-if="scope.row.availableWeight == undefined || scope.row.availableWeight == ''">0</span>
                  <span v-else>{{ Number(scope.row.availableWeight).toFixed(3) }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="warehouseName" label="仓库"></el-table-column>

          </el-table>
          <!-- 分页-->
          <div class="pags" style="text-align: right;">
            <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfoXQ.pageNo"
              :page-size="pageInfoXQ.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- dialogs -->
    <el-dialog v-loading="zuoFeiLoading" title="作废" :visible.sync="zuofeiDialog" :close-on-click-modal="false"
      @close="zuofeiClose" center>
      <el-form label-width="90px" ref="zuofeiForm" class="demo-form-inline" :model="zuofeiForm">
        <el-form-item label="作废原因:" prop="desc" :rules="[{ required: true, message: '请输入作废原因', trigger: 'blur' }]">
          <el-input class="ipt" :validate-event="false" type="textarea" v-model="zuofeiForm.desc"></el-input>
        </el-form-item>
      </el-form>
      <div style="width:158px;margin:20px auto;">
        <el-button type="" @click="zuofeiClose">取消</el-button>
        <el-button type="primary" @click="zuofeiAddOK">确定</el-button>
      </div>
    </el-dialog>
    <!-- 添加 -->
    <el-dialog v-loading="addLoading" title="添加出库计划" :visible.sync="addMarkBox" :close-on-click-modal="false"
      @close="addClose('addForm')" center width="75%">
      <el-form label-width="120px" :rules="rules" ref="addForm" :inline="true" class="demo-form-inline" :model="addForm">
        <!-- <el-form-item label="货物类型:" prop="productType">
          <el-select clearable v-model="addForm.productType" placeholder="请选择" size="mini" style="width: 190px">
              <el-option
                v-for="(item, index) in productTypeData"
                :key="index"
                :label="item.productTypeName"
                :value="item.productType"
              >
              </el-option>
            </el-select>
          <el-button type="primary" @click="addGoodsName" size="mini" style="margin-left:10px;">添加货物</el-button>
        </el-form-item> -->
        <el-form-item label="出库车牌号:" prop="plateNumber">
          <!-- <el-input  v-model="addForm.plateNumber" size="mini"  maxlength="10" style="width: 190px" placeholder="请输入出库车牌号"></el-input> -->
          <el-select clearable filterable allow-create v-model="addForm.plateNumber" placeholder="请选择" size="mini"
            @change="driverSelect" style="width: 190px">
            <el-option v-for="(item, index) in driverlist" :key="index" :label="item.plateNumber"
              :value="item.plateNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机姓名:" prop="driveName">
          <el-input v-model="addForm.driveName" size="mini" maxlength="30" style="width: 190px" placeholder="请输入司机姓名">
          </el-input>
        </el-form-item>
        <el-form-item label="司机手机号:" prop="driveTel">
          <el-input v-model="addForm.driveTel" onkeyup="value=value.replace(/[^\d]/g,'')" size="mini" maxlength="11"
            style="width: 190px" placeholder="请输入司机手机号"></el-input>
        </el-form-item>
        <el-form-item label="司机身份证号:" prop="driveId">
          <el-input v-model="addForm.driveId" size="mini" maxlength="18" style="width: 190px" placeholder="请输入司机身份证号">
          </el-input>
        </el-form-item>
        <!-- <br> -->
        <el-form-item label="备注:" prop="remarks">
          <el-input v-model="addForm.remarks" size="mini" maxlength="200" style="width: 510px" placeholder="请输入备注">
          </el-input>
        </el-form-item>
        <div>
          <div style="margin-left:20px;">
            <div>
              <span style="font-size:16px;font-weight: 700;">添加货物</span>
              <!-- <el-button type="primary" @click="addGoodsName" size="mini" style="margin-left:10px;">添加货物</el-button> -->

            </div>
            <hr />
            <div>
              <el-table size="mini" ref="tabref" :data="addTableData" style="width:100%" highlight-current-row
                :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @row-click="dianjiXiangqingtable">
                <el-table-column prop="productName" label="货物类型" width="100"></el-table-column>
                <el-table-column prop="placeOfOrigin" label="产地" width="250"></el-table-column>
                <el-table-column prop="model" label="材质" width="100"></el-table-column>
                <el-table-column prop="specification" width="120" label="规格"></el-table-column>
                <!-- <el-table-column v-if="addForm.productType == '4'||addForm.productType == '7'" prop="root" label="单件支数"></el-table-column>
              <el-table-column v-if="addForm.productType == '4'||addForm.productType == '7'" prop="length" label="长度(m)"></el-table-column> -->
                <el-table-column prop="warehouseName" label="仓位"></el-table-column>
                <el-table-column v-if="xuanzhongArr && xuanzhongArr.source != 0" prop="stockAvailableNumber" width="120"
                  label="库存可提件数"></el-table-column>
                <el-table-column prop="stockNumber" label="库存件数" width="120"></el-table-column>
                <el-table-column prop="availableNumber" label="可计划件数" width="120"></el-table-column>
                <el-table-column prop="" label="出库件数" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input v-model="addTableData[scope.$index].number" v-number-input.float="0" type="text" @blur="NumberInput(scope.row)" size="mini"></el-input> -->
                    <el-input v-model="scope.row.number" v-number-input.float="0" type="text"
                      @blur="NumberInput(scope.row)" size="mini"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="重量(吨)" width="120">
                  <template slot-scope="scope">
                    <el-input v-show="scope.row.disWeight" v-model="scope.row.weight" v-number-input.float="3" type="text"
                      @blur="NumberInputWeight(scope.row)" size="mini" :disabled='true'></el-input>
                    <el-input v-show="!scope.row.disWeight" v-model="scope.row.allWeight" v-number-input.float="3"
                      type="text" @blur="NumberInputWeight(scope.row)" size="mini" :disabled='false'></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="操作">
                  <template slot-scope="scope">
                    <div>
                      <el-button type="text" size="small" @click="deleteAdd(scope)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-form>
      <div style="width:158px;margin:20px auto;">
        <el-button type="" @click="addCancel('addForm')">取消</el-button>
        <el-button type="primary" @click="addSubmit('addForm')">确定</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <xinzeng-tidan v-if="addBillVisible" :rowBillId="rowBillId" :addBillVisible.sync='addBillVisible'
      :addRCFlag="addRCFlag" :RCList="RCList"></xinzeng-tidan>
    <el-dialog title="查看备注" :visible.sync="dialogShenheVisible" width="35%">
      <div class="demo-image__preview" v-if="!lookApproverReject" style="display: flex">
        {{ shenheYijian }}
      </div>
      <span v-if="lookApproverReject">暂无备注</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShenheVisible = false">关 闭</el-button>
        <!-- <el-button type="primary" @click="dialogVisibleImg = false"
            >确 定</el-button> -->
      </span>
    </el-dialog>
    <!-- 关联货物 -->
    <tianjia-huowu v-if="addProductTypeMark" :addProductTypeMark.sync="addProductTypeMark"
      :GuanlianHuowuRow="GuanlianHuowuRow"></tianjia-huowu>
    <!-- 关联货物. 2.0-->
    <tianjia-huowu-two v-if="addPlanVisible" :addPlanVisible.sync="addPlanVisible" :planData="planData"
      :GuanlianHuowuRow="GuanlianHuowuRow">
    </tianjia-huowu-two>
    <!-- 关联货物. 念头西库-->
    <TianjiaHuowuThree v-if="addPlanVisibleThree" :addPlanVisibleThree.sync="addPlanVisibleThree" :planData="planData"
      :GuanlianHuowuRow="GuanlianHuowuRow">
    </TianjiaHuowuThree>
    <!-- <add-ChuKuPlan v-if="addPlanVisible" :addPlanVisible.sync='addPlanVisible' :planData="planData"
          :chePai = 'chePai' @getTime = 'getTime'></add-ChuKuPlan> -->

    <!-- 添加出库计划. 2.0-->
    <tianjia-plan-two v-if="addPlanTwoVisible" :addPlanTwoVisible.sync='addPlanTwoVisible' :planData="planData"
      :chePai='chePai' @getTime='getTime'></tianjia-plan-two>
    <!-- 添加出库计划念头西库-->
    <TianjiaPlanThree v-if="addPlanThreeVisible" :addPlanThreeVisible.sync='addPlanThreeVisible' :planData="planData"
      :chePai='chePai' @getTime='getTime'></TianjiaPlanThree>
    <div>

    </div>
  </div>
</template>

<script>
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  getVirtualBalingList, // 规格
  getCustomerForBill, // 客户
  addEmptyBillDetailExp, // 保存
  getRelationCustomer, // 字典客户
  zidian,
  getTEmptyBillMasterForListZY, // 列表
  getTEmptyBillDetailList, // 货物明细列表
  cancelTEmptyBillMaster, // 作废
  getSBillFileUrl, // 查看单据
  completeTEmptyBillMaster, // 完成
  getEmptyBillDetailGroup, // 货物类型下拉框
  getEmptyBillStockSummary, // 添加货物列表
  addEmptyOutstock, // 添加货物确定
  delEmptyBillDetail, // 货物明细删除（来源手动）
  getEmptyBillStockSummarySD,
  getWeighingMethodList,
  getTEmptyBillDriverList,
  findEmptyBillDriverList,
  getDictionaryList
} from '@/api/wms-stock.js'
import XinzengTidan from './XinzengTidan.vue'
import TianjiaHuowu from './TianjiaHuowu.vue'
import TianjiaPlanTwo from './TianjiaPlanTwo.vue'
import TianjiaHuowuTwo from './TianjiaHuowuTwo.vue'
import TianjiaPlanThree from './TianjiaPlanThree.vue'
import TianjiaHuowuThree from './TianjiaHuowuThree.vue'

function sortArr (arr, str) {
  var _arr = []
  var _t = []
  // 临时的变量
  var _tmp

  // 按照特定的参数将数组排序将具有相同值得排在一起
  arr = arr.sort(function (a, b) {
    var s = a[str]
    var t = b[str]

    return s < t ? 1 : -1
  })

  if (arr.length) {
    _tmp = arr[0][str]
  }
  // console.log( arr );
  // 将相同类别的对象添加到统一个数组
  for (var i in arr) {
    // console.log( _tmp);
    if (arr[i][str] === _tmp) {
      // console.log(_tmp)
      _t.push(arr[i])
    } else {
      _tmp = arr[i][str]
      _arr.push(_t)
      _t = [arr[i]]
    }
  }
  // 将最后的内容推出新数组
  _arr.push(_t)
  return _arr
}
export default {
  name: 'ChukuBill',
  components: {
    XinzengTidan,
    TianjiaHuowu,
    TianjiaPlanTwo,
    TianjiaHuowuTwo,
    TianjiaPlanThree,
    TianjiaHuowuThree
  },
  data () {
    return {
      title: '添加货物',
      planData: {},
      chePai: '',

      guanlianVisible: false,
      kehuform: {},
      tableData1: [],
      tableData2: [],
      specificationData: [],
      productTypeData: [],
      number: '',
      customerTaxId: '',
      primaryCustomerTaxId: '',
      xuanzhonglist: {},
      searchForm: {
        pageNo: 1,
        pageSize: 20,
        billNo: '',
        nowTime: '',
        dateStart: '',
        dateEnd: '',
        primaryCustomerTaxId: '',
        secondaryCustomerTaxId: '',
        plateNumber: '',
        specification: '',
        steelMillName: '',
        emptyBillType: '',
        invalidFlag: '',
        model: '',
        outBillNo: ''
      },
      pageInfoXQ: {
        pageSize: 10,
        pageNo: 1
      },
      totalXQ: 0,
      dateList: '',
      totalA: 0,
      customerData: [], // 货主数据
      HQData: [], // 货权方
      FOwnerData: [],
      statusData: [], // 单据状态
      h: '500px',
      tableList: [],
      nowDate: '',
      tabLoadingA: false,
      subTableData: [],
      invalidFlagData: [{
        show_name: '全部',
        item_no: ''
      },
      {
        show_name: '正常',
        item_no: '0'
      },
      {
        show_name: '失效',
        item_no: '1'
      }
      ],
      btnFlg: [],
      btnIdArr: [
        '003P01CB001',
        '003P01CB002',
        '003P01CB003',
        '003P01CB004',
        '003P01CB005',
        '003P01CB006',
        '003P01CB007',
        '003P01CB008',
        '003P01CB009',
        '003P01CB00A',
        '003M2T0100',
        '003M2T0200',
        '003M2T0300'
      ],
      detailsH: '200px',
      zuofeiDialog: false,
      zuofeiForm: {
        desc: ''
      },
      xuanzhongArr: null,
      allNumber: '0',
      allWeight: '0',
      xuanzhongArrXQ: null,
      zuoFeiLoading: false,
      // 添加
      addMarkBox: false,
      addLoading: false,
      addForm: {
        productType: '',
        plateNumber: '',
        driveName: '',
        driveTel: '',
        driveId: '',
        remarks: ''
      },
      rules: {
        productType: [{
          required: true,
          message: '请选择货物类型',
          trigger: 'blur'
        }],
        plateNumber: [{
          required: true,
          message: '请输入车牌号',
          trigger: 'blur'
        },
        this.rule.vhcNo
        ],
        driveName: [{
          required: false,
          message: '请输入司机姓名',
          trigger: 'blur'
        }]
      },
      productTypeData: [], // 货物类型
      addTableData: [],
      submitData: [],
      RCList: [],
      addBillVisible: false,
      addRCFlag: false,
      rowBillId: '',
      shenheYijian: '',
      dialogShenheVisible: false,
      lookApproverReject: false,
      addProductTypeMark: false,
      addPlanVisible: false,
      addPlanVisibleThree: false, // 添加货物按钮
      addPlanTwoVisible: false,
      addPlanThreeVisible: false,
      addPlanTypeMark: false,
      GuanlianHuowuRow: {},
      driverlist: [],
      allWeightT: 0,
      allNumberT: 0
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/ChukuBill')
    console.log(this.btnFlg[9], '111')
    this.getTime()
    this.getRelationCustomer()
    this.getStatus()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    // let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 145 + 'px'
    // this.detailsH = 0.4 * pH - h2 - 60 + 'px'
  },
  methods: {

    additiveQuXiao () {
      this.guanlianVisible = false
      this.$emit('update:addPlanVisible', false)
    },
    driverSelect (val) {
      console.log(val)
      this.driverlist.forEach(item => {
        if (item.plateNumber == val) {
          this.addForm.driveName = item.driverName
          this.addForm.driveTel = item.telephone
          this.addForm.driveId = item.idNumber
        }
      })
    },
    delXQ () {
      if (this.xuanzhongArrXQ == null) {
        this.$message({
          message: '请选择一条数据',
          type: 'error'
        })
        return
      } else if (this.xuanzhongArr.emptyBillType != '0') {
        this.$message({
          message: '待处理的提货单可以删除；其他状态的提货单不能删除',
          type: 'error'
        })
        return
      } else if (this.xuanzhongArr.source != '0') {
        this.$message({
          message: '数据来源必须是手动',
          type: 'error'
        })
        return
      }
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delEmptyBillDetail({
          billId: this.xuanzhongArr.billId,
          billDetailId: this.xuanzhongArrXQ.billDetailId
        })
          .then(res => {
            console.log(res)
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getSeatchData()
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      })
    },
    xinzeng (row) {
      this.rowBillId = row.billId
      this.RCList = []
      this.addBillVisible = true
      this.addRCFlag = false
    },
    addRC (row) {
      console.log(this.rowBillId, 'this.rowBillId')
      findEmptyBillDriverList({ billId: row.billId }).then(res => {
        this.RCList = res // 客户
        this.rowBillId = row.billId

        this.addBillVisible = true
        this.addRCFlag = true
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 获取当前时间
    getTime () {
      this.nowDate = (new Date()).getTime()
      this.searchForm.nowTime = this.timeStamp(this.nowDate)
      if (this.dateList) {
        this.searchForm.dateStart = this.dateList[0] + ' 00:00:00'
        this.searchForm.dateEnd = this.dateList[1] + ' 23:59:59'
        // console.log(this.searchForm.dateStart, this.searchForm.dateEnd)
      }
      this.getSeatchData(this.searchForm)
    },
    // 时间格式化
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    timeStamp: function (value) {
      let date = new Date()
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
      let seconds = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
      date = Y + '-' + M + '-' + D + ' ' + hours + ':' + minutes + ':' + seconds
      return date
    },
    // 获取一级、二级客户
    getRelationCustomer () {
      getRelationCustomer().then(res => {
        this.customerData = res // 客户
        this.HQData = JSON.parse(JSON.stringify(res))
        this.HQData.unshift({
          'custerName': '无货权方',
          'taxpayerNumber': '-1'
        })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 货物类型
    getEmptyBillDetailGroup () {
      getEmptyBillDetailGroup({
        billId: this.xuanzhongArr.billId
      }).then(res => {
        this.productTypeData = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    getStatus () {
      zidian({
        groupNo: 'empty_bill_type'
      }).then(res => {
        this.statusData = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 查询接口
    getSeatchData () {
      this.tabLoadingA = true
      getTEmptyBillMasterForListZY(this.searchForm)
        .then((res) => {
          this.tabLoadingA = false

          this.allWeightT = res.all.allWeight
          this.allNumberT = res.all.allNumber
          res.pageInfo.list.forEach((item) => {
            if (this.nowDate > item.failureTime) {
              item.invalidFlag = '失效'
            } else {
              item.invalidFlag = '正常'
            }
          })
          this.tableList = res.pageInfo.list
          if (res.pageInfo.list.length > 0) {
            this.xuanzhongArr = res.pageInfo.list[0]
            this.$nextTick(() => {
              this.$refs.tableList.setCurrentRow(res.pageInfo.list[0])
            })
            this.getTEmptyBillDetailList()
          } else {
            this.tableList = []
            this.totalA = 0
            this.allWeight = '0'
            this.allNumber = '0'
            this.subTableData = []
            this.totalXQ = 0
          }
          this.totalA = res.pageInfo.total
        })
        .catch((err) => {
          this.tabLoadingA = false
          // console.log(err.message)
          this.$message.error(err.message)
        })
    },
    // 货物详情
    getTEmptyBillDetailList () {
      getTEmptyBillDetailList({
        billId: this.xuanzhongArr.billId,
        ...this.pageInfoXQ
      })
        .then(res => {
          // console.log(res)
          this.allWeight = res.all.allWeight
          this.allNumber = res.all.allNumber
          this.subTableData = res.pageInfo.list
          this.totalXQ = res.pageInfo.total
          this.xuanzhongArrXQ = res.pageInfo.list[0]
          // this.getThreadSummaryTotalWNs()
          // this.$nextTick(() => {
          //   this.$refs.tabref.setCurrentRow(res.list[0])
          // })
        })
        .catch(error => {
          console.log(error)
          DonMessage.error(error.message)
        })
    },
    searchClick () {
      this.getTime()
    },
    chongzhi () {
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 20
      this.searchForm.nowTime = ''
      this.searchForm.dateStart = ''
      this.searchForm.dateEnd = ''
      this.searchForm.billNo = ''
      this.searchForm.primaryCustomerTaxId = ''
      this.searchForm.secondaryCustomerTaxId = ''
      this.searchForm.plateNumber = ''
      this.searchForm.specification = ''
      this.searchForm.steelMillName = ''
      this.searchForm.emptyBillType = ''
      this.searchForm.invalidFlag = ''
      this.searchForm.ownerCustomerTaxId = ''
      this.searchForm.outBillNo = ''
      this.searchForm.model = ''
      this.dateList = ''
      this.getTime()
    },
    addPlanClick () {
      // if (this.xuanzhongArr.emptyBillType == '2') {
      //   DonMessage.error('该条数据为已作废状态不能添加')
      // } else if (this.xuanzhongArr.emptyBillType == '3') {
      //   DonMessage.error('该条数据为已完成状态不能添加')
      // }
      if (this.xuanzhongArr.emptyBillType == '2') {
        DonMessage.error('该条数据为已作废状态不能添加')
      } else if (this.xuanzhongArr.emptyBillType == '3') {
        DonMessage.error('该条数据为已完成状态不能添加')
      } else if (this.xuanzhongArr.invalidFlag == '失效') {
        DonMessage.error('该条数据已失效不能添加')
      } else {
        // this.getEmptyBillDetailGroup()
        this.planData = this.xuanzhongArr
        this.chePai = this.searchForm.plateNumber
        this.addPlanTwoVisible = true

        // this.getDictionaryLists()
      }
      //   if (this.xuanzhongArr.emptyBillType == '0' || this.xuanzhongArr.emptyBillType == '1') {
      //   this.addPlanTwoVisible = true
      //   this.planData = this.xuanzhongArr
      //   this.chePai = this.searchForm.plateNumber
      // } else {
      //   DonMessage.error('该条数据不能添加出库计划')
      // }
    },
    addPlanClick1 () {
      if (this.xuanzhongArr == null) {
        this.$message({
          message: '请先选择一条数据',
          type: 'error'
        })
        return false
      }
      if (this.xuanzhongArr.emptyBillType == '2') {
        DonMessage.error('该条数据为已作废状态不能添加')
      } else if (this.xuanzhongArr.emptyBillType == '3') {
        DonMessage.error('该条数据为已完成状态不能添加')
      } else if (this.xuanzhongArr.invalidFlag == '失效') {
        DonMessage.error('该条数据已失效不能添加')
      } else {
        this.planData = this.xuanzhongArr
        this.chePai = this.searchForm.plateNumber
        this.addPlanThreeVisible = true
      }
    },
    addPlan () {
      if (this.xuanzhongArr.emptyBillType == '2') {
        DonMessage.error('该条数据为已作废状态不能添加')
      } else if (this.xuanzhongArr.emptyBillType == '3') {
        DonMessage.error('该条数据为已完成状态不能添加')
      } else if (this.xuanzhongArr.invalidFlag == '失效') {
        DonMessage.error('该条数据已失效不能添加')
      } else {
        this.addMarkBox = true
        // this.getEmptyBillDetailGroup()
        this.addGoodsName()
        this.getTEmptyBillDriverLists()
        // this.getDictionaryLists()
      }
    },
    // 完成
    finished () {
      if (this.tableList.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      if (this.xuanzhongArr == null) {
        this.$message({
          message: '请先选择一条数据',
          type: 'error'
        })
        return false
      }
      if (this.xuanzhongArr.emptyBillType != '1') {
        this.$message({
          message: '该状态不可操作',
          type: 'error'
        })
        return false
      }
      this.$confirm('是否确定此操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        completeTEmptyBillMaster({
          billId: this.xuanzhongArr.billId // 出库提单id
        }).then(res => {
          DonMessage.success('完成成功')
          this.getTime()
        }).catch(err => {
          DonMessage.error(err.message)
        })
      }).catch(() => { })
    },
    // 作废
    cancellation () {
      if (this.xuanzhongArr) {
        if (this.xuanzhongArr.emptyBillType == '2') {
          DonMessage.error('该条数据的状态不能作废')
        } else if (this.xuanzhongArr.emptyBillType == '1') {
          DonMessage.error('正在装车，不能作废')
        } else {
          this.zuofeiDialog = true
        }
      } else {
        DonMessage.error('请选择一条数据进行操作')
      }
    },
    // 点击
    dianjixuanzhong (row) {
      console.log(row)
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.allWeight = '0'
      this.allNumber = '0'
      this.subTableData = []
      this.totalXQ = 0
      this.getTEmptyBillDetailList()
    },
    // selectGoods () {},
    dianjiXiangqingtable (row) {
      this.xuanzhongArrXQ = {}
      this.xuanzhongArrXQ = row
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.getTime()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.getTime()
    },
    // 查看图片
    handleClick (row, type) {
      if (type == 'zp') {
        let formData = new FormData()
        formData.append('url', row.path)
        getSBillFileUrl(formData).then(res => {
          this.$router.push({
            // 核心语句
            path: '/pdf', // 跳转的路径
            query: {
              // 路由传参时push和query搭配使用 ，作用时传递参数
              path: res
            }
          })
        })
      } else {
        this.dialogShenheVisible = true
        this.shenheYijian = row.remark
      }
    },
    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.getTEmptyBillDetailList()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.getTEmptyBillDetailList()
    },
    // dialog
    zuofeiClose () {
      this.zuofeiDialog = false
      this.$refs.zuofeiForm.resetFields()
      this.zuofeiForm.desc = ''
    },
    // 作废确定
    zuofeiAddOK () {
      this.$refs.zuofeiForm.validate((valid) => {
        if (valid) {
          this.zuoFeiLoading = true
          cancelTEmptyBillMaster({
            billId: this.xuanzhongArr.billId, // （出库提单id  必填）
            voidReason: this.zuofeiForm.desc // （作废原因 必填）
          }).then(res => {
            this.zuoFeiLoading = false
            DonMessage.success('作废成功')
            this.zuofeiDialog = false
            this.getTime()
          }).catch(err => {
            this.zuoFeiLoading = false
            DonMessage.error(err.message)
          })
        } else {
          return false
        }
      })
    },
    // 添加关闭
    addClose (formName) {
      this.addMarkBox = false
      this.$refs[formName].resetFields()
      this.addTableData = []
    },
    // 添加取消
    addCancel (formName) {
      this.addMarkBox = false
      this.$refs[formName].resetFields()
      this.addTableData = []
      console.log(this.addTableData, 'this.addTableData')
    },
    // 点击添加货物
    addGoodsName () {
      // if (this.addForm.productType == '') {
      //   DonMessage.error('请选择货物类型')
      // } else {
      if (this.xuanzhongArr.source == '0') {
        getEmptyBillStockSummarySD({
          billId: this.xuanzhongArr.billId
        })
          .then(res => {
            console.log(res)
            res.forEach(item => {
              item.number = ''
              item.weight = ''
              item.allWeight = ''
              item.productTypeName = item.productName
              item.disWeight = false
            })
            this.addTableData = res
            this.addTableData.forEach(item => {
              getWeighingMethodList({
                productType: item.productType
              })
                .then(res => {
                  console.log(res)
                  if (res.length > 0 && res[0].outWeighingMethod == 2) {
                    item.disWeight = false
                  } else {
                    item.disWeight = true
                  }
                })
                .catch(err => {
                  DonMessage.error(err.message)
                })
            })
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      } else {
        getEmptyBillStockSummary({
          billId: this.xuanzhongArr.billId // （出库提单id 必填）
          // productType: this.addForm.productType// （货物类型id 必填
        }).then(res => {
          res.forEach(item => {
            item.number = ''
            item.disWeight = false
            item.weight = ''
            item.allWeight = ''

            item.productTypeName = item.productName
          })
          this.addTableData = res
          this.addTableData.forEach(item => {
            getWeighingMethodList({
              productType: item.productType
            })
              .then(res => {
                console.log(res)
                if (res.length > 0 && res[0].outWeighingMethod == 2) {
                  item.disWeight = false
                } else {
                  item.disWeight = true
                }
              })
              .catch(err => {
                DonMessage.error(err.message)
              })
          })
          console.log(this.addTableData, 'this.addTableData')
        }).catch(err => {
          DonMessage.error(err.message)
        })
      }

      // }
    },
    NumberInput (val) {
      if (val.stockAvailableNumber && val.number > val.stockAvailableNumber) {
        this.$message({
          message: '出库件数不能大于库存可提件数',
          type: 'error'
        })
        val.number = ''
        val.weight = ''
        val.allWeight = ''
        return
      }
      // console.log(val)
      val.weight = (val.number / 1 * val.singletonWeight / 1).toFixed(3)
      val.allWeight = (val.number / 1 * val.singletonWeight / 1).toFixed(3)
    },
    NumberInputWeight (val) {
      console.log(val)
      // val.weight = Number(val.weight).toFixed(3)
      // val.weight = (val.number / 1 * val.singletonWeight / 1).toFixed(3)

      val.allWeight = Number(val.allWeight).toFixed(3)
    },
    // 删除
    deleteAdd (scope) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.addTableData.splice(scope.$index, 1)
      })
    },
    // 添加确定
    addSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addTableData.every(item => item.number / 1 == 0)) {
            console.log(111)
            DonMessage.error('请填写至少一条数据')
            return
          }
          this.submitData = sortArr(this.addTableData, 'billDetailId')
          console.log(this.submitData)
          for (let i = 0; i < this.submitData.length; i++) {
            let num = 0
            let weightSum = ''
            console.log(this.submitData[i], '222')
            for (let j = 0; j < this.submitData[i].length; j++) {
              num = num / 1 + this.submitData[i][j].number / 1
              if (this.submitData[i][j].allWeight / 1 != 0) {
                weightSum = weightSum / 1 + this.submitData[i][j]
                  .allWeight / 1
              }
              if (num > this.submitData[i][j].availableNumber) {
                DonMessage.error('所填写的出库件数不能大于可计划件数')
                return false
              }
              // if (weightSum != '' && weightSum > this.submitData[i][j].availableWeight) {
              //   DonMessage.error('出库重量不能超过可计划重量')
              //   return false
              // }
            }
          }
          let tableData = this.addTableData.filter(item => item.number != '')

          // this.addTableData.forEach((item, index) => {
          //   // item.allWeight = item.weight
          //   if (item.number / 1 == 0) {
          //     this.addTableData.splice(index, 1)
          //   }
          // }))

          this.addLoading = true

          addEmptyOutstock({
            billId: this.xuanzhongArr.billId,
            tEmptyOutstockMaster: {
              primaryCustomerName: this.xuanzhongArr.primaryCustomerName, // 一级货主名称  必填）
              primaryCustomerTaxId: this.xuanzhongArr.primaryCustomerTaxId, // 一级货主id  必填
              customerName: this.xuanzhongArr.secondaryCustomerName, // 二级货主名称  必填
              customerTaxId: this.xuanzhongArr.secondaryCustomerTaxId, // 二级货主id
              // productType: this.addForm.productType, // 货物类型id
              // productTypeName: this.productTypeData.filter(item => item.productType == this.addForm.productType)[0].productTypeName,
              outstockPlateNumber: this.addForm.plateNumber, // 出库车牌号
              driverName: this.addForm.driveName, // 司机姓名
              carHoldFalg: this.xuanzhongArr.carHoldFalg, // 扣车标记 0：不扣，1：扣车
              telephone: this.addForm.driveTel, // 司机手机
              idNumber: this.addForm.driveId, // 身份证号
              remark: this.addForm.remarks

            },
            list: tableData
          })
            .then(res => {
              console.log(res)
              this.addLoading = false
              DonMessage.success('添加成功')
              this.$refs[formName].resetFields()
              this.addTableData = []
              this.addMarkBox = false
              this.getTime()
            })
            .catch(err => {
              this.addLoading = false

              DonMessage.error(err.message)
            })
        } else {
          this.addLoading = false

          return false
        }
      })
    },

    tianjiahuowuTwo (row) {
      this.xuanzhongArr = row
      this.planData = this.xuanzhongArr

      if (this.xuanzhongArr.source != 0) {
        this.$message({
          message: '数据来源必须是手动',
          type: 'error'
        })
        return
      } else if (this.xuanzhongArr.emptyBillType != '0') {
        this.$message({
          message: '待处理的提货单可以添加货物；其他状态的提货单不能添加货物',
          type: 'error'
        })
        return
      }
      this.addPlanVisible = true

      // this.GuanlianHuowuRow = row
    },
    tianjiahuowuTwo1 (row) {
      this.xuanzhongArr = row
      this.planData = this.xuanzhongArr

      if (this.xuanzhongArr.source != 0) {
        this.$message({
          message: '数据来源必须是手动',
          type: 'error'
        })
        return
      } else if (this.xuanzhongArr.emptyBillType != '0') {
        this.$message({
          message: '待处理的提货单可以添加货物；其他状态的提货单不能添加货物',
          type: 'error'
        })
        return
      }
      this.addPlanVisibleThree = true
    },
    tianjiahuowu (row) {
      this.xuanzhongArr = row
      if (this.xuanzhongArr.source != 0) {
        this.$message({
          message: '数据来源必须是手动',
          type: 'error'
        })
        return
      } else if (this.xuanzhongArr.emptyBillType != '0') {
        this.$message({
          message: '待处理的提货单可以添加货物；其他状态的提货单不能添加货物',
          type: 'error'
        })
        return
      }
      this.addProductTypeMark = true

      this.GuanlianHuowuRow = row
    },
    getTEmptyBillDriverLists () {
      getTEmptyBillDriverList({
        billId: this.xuanzhongArr.billId
      })
        .then(res => {
          console.log(res)
          this.driverlist = res
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    getDictionaryLists () {
      getDictionaryList({
        tenantCode: window.localStorage.getItem('tenantCode'),
        groupNo: 'out_empty_remark'
      })
        .then(res => {
          console.log(res)
          this.addForm.remarks = res[0].remark
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    }
  }

}

</script>

<style lang="less" scoped>

.detailsTitle-sum {
  padding-left: 20px;

  .num {
    color: rgb(224, 0, 32)
  }
}
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}
.detailsTitle{
  margin-bottom: 0;
}

</style>
